import { env } from '@percent/cause-dashboard/env'

const DEFAULT_TEST_API_URL = 'http://localhost:8080/'
const DEFAULT_TEST_APP_URL = 'https://localhost:3000'
const DEFAULT_TEST_TERMS_URL = 'https://localhost:3000/legal'
const DEFAULT_TEST_DONATION_LINK_ID = 'test_donation_link_id'
const DEFAULT_TEST_PK_KEY = 'test_pk_key'
const DEFAULT_TEST_ORG_SEARCH_PK_KEY = 'test_org_search_pk_key'
const DEFAULT_TEST_ZENDESK_CHAT_KEY = 'test_zendesk_chat_key'
const DEFAULT_TEST_HUBSPOT_WIDGET_KEY = '123456789'
const DEFAULT_PRIVACY_POLICY_URL = 'https://localhost:3000/legal/#privacy-policy'
const DEFAULT_DONATION_WIDGET_URL = 'https://stating-scripts.localhost:3000/donation-widget-v1.js'

const envConfig = (() => {
  const obj = {
    urls: {
      api: '',
      app: '',
      terms: '',
      privacyAndPolicy: '',
      poweredByPercent: '',
      donationWidget: '',
      notificationBannerLink: env.NX_CAUSE_PORTAL_NOTIFICATION_BANNER_URL,
      goodstack: ''
    },
    keys: {
      ga: '',
      client_id: '',
      zendeskChatKey: env.NX_PUBLIC_CAUSE_PORTAL_ZENDESK_CHAT_KEY ?? '',
      hubspotWidgetKey: env.NX_PUBLIC_REACT_APP_HUBSPOT_WIDGET_KEY ?? '',
      pk: '',
      orgSearchPk: '',
      googleCaptchaEnterprise: env.NX_PUBLIC_CAUSE_PORTAL_GOOGLE_RECAPTCHA_ENTERPRISE_KEY ?? '',
      googleMaps: env.NX_PUBLIC_CAUSE_PORTAL_GOOGLE_MAPS_API_KEY ?? '',
      recaptchaSiteKey: env.NX_PUBLIC_RECAPTCHA_SITE_KEY ?? '',
      geolocation: env.NX_PUBLIC_REACT_APP_GEOLOCATION_API_KEY ?? ''
    },
    ids: {
      donationLink: ''
    },
    promotionalPopup: {
      shortBreakTme: parseInt(env.NX_PUBLIC_CAUSE_PORTAL_POPUP_SHORT_BREAK_TIME ?? '30'),
      longBreakTime: parseInt(env.NX_PUBLIC_CAUSE_PORTAL_POPUP_LONG_BREAK_TIME ?? '20160')
    },
    strings: {
      notificationBanner: {
        textKey: env.NX_PUBLIC_CAUSE_PORTAL_NOTIFICATION_BANNER_TEXT_KEY,
        buttonKey: env.NX_PUBLIC_CAUSE_PORTAL_NOTIFICATION_BANNER_BUTTON_KEY
      }
    }
  }

  if (env.NX_PUBLIC_TEST_MODE === true) {
    obj.urls.api = DEFAULT_TEST_API_URL
    obj.urls.app = DEFAULT_TEST_APP_URL
    obj.urls.terms = DEFAULT_TEST_TERMS_URL
    obj.urls.privacyAndPolicy = DEFAULT_PRIVACY_POLICY_URL
    obj.urls.donationWidget = DEFAULT_DONATION_WIDGET_URL
    obj.ids.donationLink = DEFAULT_TEST_DONATION_LINK_ID
    obj.keys.pk = DEFAULT_TEST_PK_KEY
    obj.keys.orgSearchPk = DEFAULT_TEST_ORG_SEARCH_PK_KEY
    obj.keys.zendeskChatKey = DEFAULT_TEST_ZENDESK_CHAT_KEY
    obj.keys.hubspotWidgetKey = DEFAULT_TEST_HUBSPOT_WIDGET_KEY
  } else {
    obj.urls.api = `${env.NX_PUBLIC_API_URL}`
    obj.urls.app = `${env.NX_PUBLIC_APP_URL}`
    obj.urls.terms = `${env.NX_PUBLIC_APP_TERMS_URL}`
    obj.urls.privacyAndPolicy = `${env.NX_PUBLIC_APP_PRIVACY_AND_POLICY_URL}`
    obj.urls.donationWidget = `${env.NX_PUBLIC_DONATION_WIDGET_URL}`
    obj.ids.donationLink = `${env.NX_PUBLIC_DONATION_LINK}`
    obj.keys.pk = `${env.NX_PUBLIC_PK_KEY}`
    obj.keys.orgSearchPk = `${env.NX_PUBLIC_ORG_SEARCH_PK_KEY}`
    obj.keys.zendeskChatKey = `${env.NX_PUBLIC_ZENDESK_CHAT_KEY}`
    obj.keys.hubspotWidgetKey = `${env.NX_PUBLIC_REACT_APP_HUBSPOT_WIDGET_KEY}`
  }

  return obj
})()

export const config = {
  ...envConfig,
  version: '1.0.0'
}

export type AppConfig = typeof config
